const ScoreBoard = ({ score }) => {
  return (
    <div>
      <div className="score-board">
        <h2>{score}</h2>
      </div>
    </div>
  );
};

export default ScoreBoard;
